export default {
    'add-new-salary': ' إضافة راتب جديد لموظف',
    'use-excel-file': 'استخدم ملف اكسل'
}